import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const GreyBGContainer = styled(Box)`
  background-color: var(--light);
`;
